import React from 'react';
import NameStep from 'screens/FormSteps/NameStep';
import ContactStep from 'screens/FormSteps/ContactStep';
import LocationStep from 'screens/FormSteps/LocationStep';
import ProjectStep from 'screens/FormSteps/ProjectStep';

/**
 * Renders the appropriate form step based on the `currentStep` prop value.
 *
 * @param {Object} props - The component's props.
 * @param {number} props.currentStep - The current step of the form.
 * @returns {React.Component} The corresponding form step component.
 */
const CurrentStep = ({ currentStep }) => {
  switch (currentStep) {
    case 0:
      return <NameStep />;
    case 1:
      return <ContactStep />;
    case 2:
      return <LocationStep />;
    case 3:
      return <ProjectStep />;
    default:
      return null;
  }
};

export default CurrentStep;
